// import axios from 'axios';

import { CheckBadgeIcon, ClipboardDocumentCheckIcon, PencilSquareIcon } from "@/icons/solid";
import { ChartPieIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Cell, Legend, Pie, PieChart, Tooltip } from "recharts";
import { Actions as PAYMENTACTIONS } from "../../../store/actions/paymentActions";
import { Actions as ACTIONS } from "../../../store/actions/payrollActions";

const PayrollSummary = ({
	employeesNotReady,
	departmentChartData,
	departments,
	summaryChartData,
	summary,
	payPeriodDetails,
	currency,
	chartsOnly,
	updatePayPeriodStatus,
	payrollHasBeenApproved: payrollApproved,
	company,
	clientReviewsPayroll,
	userIsAdvisor,
	adminsCanProcessPayroll,
	handleConclude,
}) => {
	const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

	const message = (() => {
		if (userIsAdvisor && payrollApproved) {
			return `${company?.name} has approved this payroll. You may now continue to conclude and submit this payroll!`;
		}
		if (!userIsAdvisor && payrollApproved) {
			return `You have approved this payroll. Your advisor will now be able to conclude and submit this payroll!`;
		}
		return `We know it's no easy feat. You can save the payroll and come back to it later, or conclude it right now.`;
	})();

	return (
		<div>
			<div className="block-content pt-0">
				{!chartsOnly && (
					<div className="block text-center pt-0">
						<div id="almost-done">
							<div className="block-content pt-0 block-content-full">
								<span className="item item-circle bg-primary">
									<ChartPieIcon style={{ height: "1.5em", marginTop: 9 }} />
								</span>
							</div>
							<div className="main">
								<h1 className="font-w700 text-center">Almost done!</h1>
								<p className="text-center">
									Congratulations on getting all the numbers in place! {message}
								</p>
							</div>
						</div>
					</div>
				)}
				<div
					style={{
						display: "grid",
						gridGap: "1.5rem",
						grid: "1.5rem",
						gridTemplateColumns: "repeat(6, minmax(0, 1fr))",
					}}
				>
					{departmentChartData?.length > 0 && (
						<div style={{ gridColumn: "span 3 / span 6" }}>
							<PieChart
								width={250}
								height={250}
								style={{ margin: "auto" }}
							>
								<Pie
									label
									data={departmentChartData}
									dataKey="value"
									nameKey="name"
									cx="50%"
									cy="50%"
									outerRadius={80}
								>
									{departmentChartData.map((entry, index) => (
										<Cell
											key={`cell-${index}`}
											fill={COLORS[index % COLORS.length]}
										/>
									))}
									{/* <LabelList dataKey="name" position="middle" /> */}
								</Pie>
								<Tooltip />
								<Legend
									verticalAlign="top"
									height={36}
								/>
							</PieChart>
						</div>
					)}

					{summaryChartData?.length > 0 && (
						<div style={{ gridColumn: "span 3 / span 6", lineHeight: "38px" }}>
							<PieChart
								width={250}
								height={250}
								style={{ margin: "auto" }}
							>
								<Pie
									label
									data={summaryChartData}
									dataKey="value"
									nameKey="name"
									cx="50%"
									cy="50%"
									outerRadius={80}
								>
									{summaryChartData.map((entry, index) => (
										<Cell
											key={`cell-${index}`}
											fill={COLORS[index % COLORS.length]}
										/>
									))}
									{/* <LabelList dataKey="name" position="middle" /> */}
								</Pie>
								<Tooltip />
								<Legend
									verticalAlign="top"
									height={36}
								/>
							</PieChart>
						</div>
					)}
				</div>
				<div
					style={{
						display: "grid",
						gridGap: "1.5rem",
						grid: "1.5rem",
						gridTemplateColumns: `repeat(${Object.keys(summary.taxes).length + 2}, minmax(0, 1fr))`,
						placeItems: "center",
					}}
				>
					<div style={{ gridColumn: "span 1 / span 1", textAlign: "center" }}>
						<strong>Gross</strong>
						<div>
							{currency} {(summary.gross || 0).toFixed(2)}
						</div>
					</div>
					<div style={{ gridColumn: "span 1 / span 1", textAlign: "center" }}>
						<strong>Net</strong>
						<div>
							{currency} {(summary.net || 0).toFixed(2)}
						</div>
					</div>
					{Object.keys(summary.taxes).map((taxName) => (
						<div style={{ gridColumn: "span 1 / span 1", textAlign: "center" }}>
							<strong> {taxName} </strong>
							<div>
								{currency}{" "}
								{(summary.taxes[taxName].employee + summary.taxes[taxName].employer || 0).toFixed(2)}
							</div>
						</div>
					))}
				</div>
			</div>
			{!chartsOnly && (
				<div className="block text-center">
					{!!(employeesNotReady > 0) && (
						<div
							className="alert alert-warning"
							style={{ color: "#232a32" }}
						>
							<ExclamationTriangleIcon style={{ height: "2em", marginRight: 10 }} />
							<div>
								{employeesNotReady} employee{employeesNotReady > 0 && "s"} have not been locked. When
								all the locks turn green, you have processed payroll for all your team. If specific
								employees did not work this period, you can choose to proceed regardless. However no
								payslip will be issued for the individual.
							</div>
						</div>
					)}

					<div className="block buttons center">
						{(!clientReviewsPayroll || !payrollApproved) && (
							<>
								<Link
									className="btn btn-default"
									type="button"
									to="../"
								>
									Go Back
								</Link>
								<Link
									to="/organisation/people"
									className="btn btn-warning"
									type="button"
								>
									Save &amp; Exit
								</Link>
							</>
						)}
						{userIsAdvisor && clientReviewsPayroll && payrollApproved && (
							<button
								className="btn btn-default"
								onClick={() => updatePayPeriodStatus(payPeriodDetails.id, "Open")}
							>
								<PencilSquareIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Reopen Payroll</div>
							</button>
						)}

						{(userIsAdvisor || adminsCanProcessPayroll) && clientReviewsPayroll && !payrollApproved && (
							<button
								className="btn btn-success"
								onClick={() => updatePayPeriodStatus(payPeriodDetails.id, "Awaiting Approval")}
							>
								<ClipboardDocumentCheckIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Send for Approval</div>
							</button>
						)}
						{(!clientReviewsPayroll || (userIsAdvisor && payrollApproved)) && (
							<button
								className="btn btn-success"
								type="button"
								onClick={(e) => {
									e.stopPropagation();
									handleConclude();
								}}
							>
								<CheckBadgeIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Conclude Payroll</div>
							</button>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

const mapStateToProps = (state) => {
	const payPeriodDetails = state.payroll?.payPeriodDetails;

	const employees = state.payroll?.employees?.filter((e) =>
		e.salaries.find(
			(s) =>
				!s.paySchedule ||
				(payPeriodDetails &&
					[payPeriodDetails.paySchedule, String(payPeriodDetails.payPeriods)].includes(
						String(s.paySchedule),
					)),
		),
	);
	const creditsUsedThisPayroll = state?.payroll?.creditsUsed;

	const departments = {};

	const summary = {
		payslips: 0,
		basicHours: 0,
		basicPay: 0,
		gross: 0,
		ptGross: 0,
		otherGross: 0,
		totalLeaveHours: 0,
		totalLeaveValue: 0,
		totalEmployeeTax: 0,
		totalEmployerTax: 0,
		totalCost: 0,
		totalTaxDue: 0,
		net: 0,
		covid19Grant: 0,
		benefitBreakdown: {},
		leave: {},
		allowances: {},
		taxes: {},
	};

	console.log("PayrollSummaryEmployees", employees);

	employees &&
		employees
			.filter(
				(employee) =>
					employee.employmentTypeName !== "External Contractor" &&
					employee?.payslip?.ready &&
					(employee?.payslip?.ready == true || employee?.payslip?.ready != "no"),
			)
			.map((employee) => {
				const payslip = employee?.payslip;
				console.log("payslip employee", payslip, employee);
				summary.payslips++;
				summary.basicHours += payslip.basicHours ? payslip.basicHours : 0;
				summary.basicPay += payslip.basicPay ? parseFloat(payslip.basicPay) : 0;
				summary.gross += payslip.gross ? parseFloat(payslip.gross) : 0;
				summary.net += payslip.net ? parseFloat(payslip.net) : 0;

				payslip?.leave?.map((leave) => {
					if (!summary.leave[leave.name]) {
						summary.leave[leave.name] = {
							amount: 0,
							hours: 0,
							paidHours: 0,
							halfPayHours: 0,
							unpaidHours: 0,
						};
					}

					summary.totalLeaveHours += leave.hours;
					summary.totalLeaveValue += leave.amount;

					summary.leave[leave.name].hours += leave.hours;
					summary.leave[leave.name].amount += leave.amount;
					summary.leave[leave.name].paidHours += leave.paidHours;
					summary.leave[leave.name].halfPayHours += leave.halfPayHours;
					summary.leave[leave.name].unpaidHours += leave.unpaidHours;
				});

				payslip?.allowances?.map((allowance) => {
					if (!summary.allowances[allowance.name]) {
						summary.allowances[allowance.name] = {
							input: 0,
							amount: 0,
							instances: 0,
							isOvertime: allowance.isOvertime,
							type: allowance.type,
							allowanceType: allowance.type,
							method: allowance.method,
							taxable: allowance.taxable,
						};
					}
					summary.allowances[allowance.name].input += allowance.hours;
					summary.allowances[allowance.name].amount += allowance.amount;
					summary.allowances[allowance.name].instances++;

					if ([622673, 1249514, 1232625, 1426588, 1402299].includes(allowance.type)) {
						// this is COVID19
						summary.covid19Grant += allowance.amount;
					}
				});

				let totalEmployerTaxThisPayslip = 0;
				let totalEmployeeTaxThisPayslip = 0;

				payslip?.taxes?.map((tax) => {
					// console.log('tax',tax);
					if (!summary.taxes[tax?.taxVariable?.taxName]) {
						summary.taxes[tax?.taxVariable?.taxName] = {
							employerTaxable: 0,
							employeeTaxable: 0,
							employee: 0,
							employer: 0,
							employeeInstances: 0,
							employerInstances: 0,
							categories: {},
						};
					}
					if (!summary.taxes[tax?.taxVariable?.taxName].categories[tax?.taxVariable?.taxCategory]) {
						summary.taxes[tax?.taxVariable?.taxName].categories[tax?.taxVariable?.taxCategory] = {
							employerTaxable: 0,
							employeeTaxable: 0,
							employee: 0,
							employer: 0,
							employeeInstances: 0,
							employerInstances: 0,
						};
					}
					summary.taxes[tax?.taxVariable?.taxName].employee += ["Employee", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? tax.amount
						: 0;
					summary.taxes[tax?.taxVariable?.taxName].employer += ["Employer", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? tax.amount
						: 0;

					summary.taxes[tax?.taxVariable?.taxName].employeeTaxable += ["Employee", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? tax.earningsTaxed
						: 0;
					summary.taxes[tax?.taxVariable?.taxName].employerTaxable += ["Employer", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? tax.earningsTaxed
						: 0;

					summary.taxes[tax?.taxVariable?.taxName].employeeInstances += ["Employee", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? 1
						: 0;
					summary.taxes[tax?.taxVariable?.taxName].employerInstances += ["Employer", "Both"].includes(
						tax?.taxVariable?.payer,
					)
						? 1
						: 0;

					summary.taxes[tax?.taxVariable?.taxName].categories[tax?.taxVariable?.taxCategory].employee += [
						"Employee",
						"Both",
					].includes(tax?.taxVariable?.payer)
						? tax.amount
						: 0;
					summary.taxes[tax?.taxVariable?.taxName].categories[tax?.taxVariable?.taxCategory].employer += [
						"Employer",
						"Both",
					].includes(tax?.taxVariable?.payer)
						? tax.amount
						: 0;

					summary.taxes[tax?.taxVariable?.taxName].categories[
						tax?.taxVariable?.taxCategory
					].employeeTaxable += ["Employee", "Both"].includes(tax?.taxVariable?.payer) ? tax.earningsTaxed : 0;
					summary.taxes[tax?.taxVariable?.taxName].categories[
						tax?.taxVariable?.taxCategory
					].employerTaxable += ["Employer", "Both"].includes(tax?.taxVariable?.payer) ? tax.earningsTaxed : 0;

					summary.taxes[tax?.taxVariable?.taxName].categories[
						tax?.taxVariable?.taxCategory
					].employeeInstances += ["Employee", "Both"].includes(tax?.taxVariable?.payer) ? 1 : 0;
					summary.taxes[tax?.taxVariable?.taxName].categories[
						tax?.taxVariable?.taxCategory
					].employerInstances += ["Employer", "Both"].includes(tax?.taxVariable?.payer) ? 1 : 0;

					totalEmployerTaxThisPayslip += ["Employer", "Both"].includes(tax?.taxVariable?.payer)
						? tax.amount
						: 0;
					totalEmployeeTaxThisPayslip += ["Employee", "Both"].includes(tax?.taxVariable?.payer)
						? tax.amount
						: 0;
				});

				summary.totalEmployeeTax += totalEmployeeTaxThisPayslip;
				summary.totalEmployerTax += totalEmployerTaxThisPayslip;
				summary.totalCost += parseFloat(payslip.gross || 0) + totalEmployerTaxThisPayslip;
				summary.totalTaxDue += totalEmployeeTaxThisPayslip + totalEmployerTaxThisPayslip;

				const employeeDepartment =
					state?.company?.settings?.departments?.filter((department) => {
						return department.id == employee.department;
					})[0]?.name || "Employees Without Department";

				if (employeeDepartment) {
					if (!departments[employeeDepartment]) {
						departments[employeeDepartment] = 0;
					}
					departments[employeeDepartment] += parseFloat(payslip.gross || 0);
				}
			});

	const departmentChartData = Object.keys(departments).map((department) => ({
		name: department,
		value: departments[department] ? parseFloat(departments[department].toFixed(2)) : 0,
	}));

	const summaryChartData = [
		{ name: "Net", value: parseFloat(summary.net.toFixed(2)) },
		...Object.keys(summary.taxes).map((taxName) => ({
			name: taxName,
			value: parseFloat((summary.taxes[taxName].employee + summary.taxes[taxName].employer).toFixed(2)),
		})),
	];
	// Object.keys(summary)
	// .filter(name => name != 'gross')
	// .map(name => ({
	//   name,
	//   value: summary[name] ? parseFloat(summary[name].toFixed(2)) : 0
	// }))

	// console.log('PayrollSummaryEmployees summary',summary)
	// console.log('PayrollSummaryEmployees departments',departments)
	// console.log(' PayrollSummaryEmployees departmentChartData',departmentChartData)

	const RADIAN = Math.PI / 180;
	const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		return (
			<text
				x={x}
				y={y}
				fill="white"
				textAnchor={x > cx ? "start" : "end"}
				dominantBaseline="central"
			>
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		);
	};

	const stats = state.payment.stats;

	const creditsRequired =
		!state.company?.settings?.isDemo &&
		stats &&
		state.payroll.employees?.length - creditsUsedThisPayroll > stats.creditBalance;

	const creditBalance = stats && stats.creditBalance;
	const isDemo =
		stats &&
		stats.businessDetails &&
		stats.businessDetails.companyName &&
		stats.businessDetails.companyName == "Demo Company";

	// TODO remove this once we get invoice function set up.
	const paidByAdvisor =
		stats &&
		stats.businessDetails &&
		stats.businessDetails.companyName &&
		stats.businessDetails.paidByAdvisor == "yes";

	const employeesNotReady = employees?.filter(
		(employee) =>
			employee.employmentTypeName !== "External Contractor" &&
			!(
				employee.payslip?.ready &&
				(employee.payslip?.ready === true || employee.payslip?.ready?.toLowerCase() !== "no")
			),
	);

	console.log("employeesNotReady", employeesNotReady);

	const { isAdmin } = state?.my?.profile || {};

	const clientReviewsPayroll = state?.company?.settings?.clientReviewsPayroll && state.company?.settings?.advisor;
	const userIsAdvisor = state?.my?.profile?.advisorId === state.company?.settings?.advisor || isAdmin;

	return {
		...state.payroll,
		company: state.company?.settings,
		payPeriodDetails: state.payroll?.payPeriodDetails,
		employeesNotReady: employeesNotReady?.length,
		departmentChartData,
		departments,
		summaryChartData,
		currency: state?.company?.settings?.currency,
		summary,
		creditsRequired: !isDemo && !paidByAdvisor && creditsRequired,
		creditBalance,
		payrollHasBeenApproved: state.payroll.payPeriodDetails?.status == "Approved",
		clientReviewsPayroll,
		userIsAdvisor,
		adminsCanProcessPayroll: state.company?.settings?.adminsCanProcessPayroll,
		jurisdiction: state.jurisdiction?.countryCode,
		// ...state.employees,
	};
};

const mapDispatchToProps = (dispatch) => ({
	payrollPageToggle: (page) => dispatch(ACTIONS.payrollPageToggle(page)),
	updatePayPeriodStatus: (id, status) => dispatch(ACTIONS.updatePayPeriodStatus(id, status)),
	showPricingModal: () => dispatch(PAYMENTACTIONS.showPricingModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollSummary);
